import Home from "pages/Home";
import Navbar from "./layout/Navbar";

import Footer from "layout/Footer";
import About from "pages/About";
import Connect from "pages/Connect";
import Living from "pages/Living";
import Process from "pages/Process";
import Solutions from "pages/Solutions";
import Testimonials from "pages/Testimonials";
import { Element } from "react-scroll";
function App() {
    return (
        <>
            <Navbar />
            <Element name="Home"><Home /></Element>
            <Element name="Living"><Living /></Element>
            <Element name="Solution"><Solutions /></Element>
            <Element name="Process"><Process /></Element>
            <Element name="About"><About /></Element>
            <Testimonials />
            <Element name="Connect"><Connect /></Element>
            <Footer />


        </>
    );
}

export default App;
